<script setup lang="ts">

import { useCarouselDots } from './use-carousel-dots'

const { selectedIndex, scrollSnaps } = useCarouselDots()

defineProps<{
  suffix: string;
}>()

</script>

<template>
  <div class="text-badge-lg font-badge text-primary-500 flex flex-row">
    <span class="hidden sm:block">{{ selectedIndex + 1 }}</span>
    <span class="hidden sm:block">/</span>
    <span>{{ scrollSnaps.length }}</span>
    <span class="ml-1">{{ suffix }}</span>
  </div>
</template>
